import * as React from 'react'
import { css, cx } from '@emotion/css'
import { FlowMapColumnTitle } from '../../column-title'
import {
  columnMarginTop,
  componentsColumnWidth,
  getColumnContainerStyle
} from '../../index'

export class BackendSystemsColumn extends React.Component<{}> {
  public render() {
    return (
      <div
        className={cx(
          getColumnContainerStyle(componentsColumnWidth, columnMarginTop),
          css`
            cursor: default;
          `
        )}
      >
        <FlowMapColumnTitle
          titleI18n={'title_applicationFlowMap_backendSystems'}
        />
      </div>
    )
  }
}
